import Text from '../../../atoms/Text';
import Image from '../../../atoms/Image';

const NavItem = ({ title, icon, active, blue, onClick }: any) => (
  <div
    className={`global_footer_mobile__block ${
      active
        ? 'global_footer_mobile__block--active'
        : 'global_footer_mobile__block--normal'
    }`}
    onClick={onClick}
  >
    <Image size='m' src={icon} />
    <Text
      size={12}
      className={`global_footer_mobile__item_text ${
        blue ? 'global_footer_mobile__item_text--navy' : ''
      }`}
    >
      {title}
    </Text>
  </div>
);

export default NavItem;